import React from "react";
import { Heart } from "lucide-react";

/**
 * Branded loading indicator — a beating heart, used in place of spinner circles
 * "wherever the app is waiting". Uses the SAME heart glyph as the logo (lucide Heart,
 * filled, #DD2E44) so the pumping heart is a proper heart, not a "V".
 * Animation: global `.heart-beat` (index.html).
 */
export default function HeartLoader({ size = 40, label = "", className = "", testid = "heart-loader" }) {
  return (
    <div className={`flex flex-col items-center justify-center gap-3 ${className}`} data-testid={testid}>
      <Heart
        className="heart-beat fill-current"
        strokeWidth={2}
        width={size}
        height={size}
        style={{ color: "#DD2E44", filter: "drop-shadow(0 0 14px rgba(221,46,68,0.5))" }}
        aria-label={label || "Loading"}
      />
      {label && <div className="text-sec text-sm">{label}</div>}
    </div>
  );
}
